import React, { useMemo } from "react";
import { getStorageValues } from "../../../shared/CommonFunctions";
import ReportViewer from "./components/ReportViewer";
import { generateStandardReportPdf } from "./utils/reportPdfGenerators";

export default function UpcomingDeliveryReport() {
  const columns = useMemo(
    () => [
      { name: "Sales #", selector: (r) => r.SalesNumber || "-" },
      { name: "Customer", selector: (r) => r.CustomerName || "-" },
      { name: "Mobile", selector: (r) => r.MobileNumber || r.MobileNo || "-" },
      { name: "Payment Mode", selector: (r) => r.PaymentTypeSummary || r.PaymentMode || "-" },
      { name: "Status", selector: (r) => r.Status || "-" },
    ],
    []
  );

  return (
    <ReportViewer
      reportKey="upcomingDelivery"
      title="Upcoming Delivery"
      columns={columns}
      fetchConfig={{
        url: "/handoverregister/eligible",
        paramsBuilder: () => ({ UserId: getStorageValues("userId") }),
        transform: (data) => {
          if (Array.isArray(data)) return data;
          if (Array.isArray(data?.[0])) return data[0];
          return [];
        },
      }}
      buildKpis={(rows) => [{ label: "Upcoming", value: rows?.length ?? 0 }]}
      pdfGenerator={generateStandardReportPdf}
    />
  );
}

